/* eslint-disable */
import React, { Component } from 'react'
import { View, Image } from 'react-native'
import { Text } from 'native-base';
import { Images } from '../Themes'
import I18n from "i18n-js"

class Outofdate extends Component {
  render( ) {
    console.log("out of date render")

    return (
      <View style={{ flex : 1, flexDirection : 'column', alignItems : 'center', backgroundColor : 'white' }}>
        <View style={{ width : '100%', marginTop : 20, paddingBottom : 10, alignItems : 'center' /*, borderBottomWidth : 1, borderColor : 'black'*/ }}>
        <Image source={Images.kargoeLogoHome} resizeMode='contain' style={{ width : '30%'}} />
          {/*
          <Text style={{ width : '100%', textAlign : 'center', fontSize : 18, color : 'black' }}>
            {I18n.t("login.updateNow")}
          </Text>
          */}

        </View>
        <Image source={Images.outofdate} resizeMode='contain' style={{ width : '50%', height: '30%', marginTop : 40, marginBottom : 50 }} />
        <Text style={{ fontSize : 18, fontWeight : 'bold', textAlign : 'center', textAlign : 'center', color : 'black', width : '75%', height : 30 }}>
          {I18n.t("login.outofdateTitle")}
        </Text>
        <Text style={{ fontSize : 18, textAlign : 'center', textAlign : 'center', color : 'black', width : '75%', height : 150 }}>
          {I18n.t("login.outofdate")}
        </Text>
      </View>
    )
  }
}

export default Outofdate
